// 该文件记录特殊的单式玩法分类对应关系
export const SPECIAL_SINGLE = {
	// PK10 急速赛马、pk10猜名次
	rank: {
		matcherNames: ["前二-猜前二-单式", "前三-猜前三-单式", "前四-猜前四-单式", "前五-猜前五-单式", "前六-猜前六-单式", "前二-前二-单式", "前三-前三-单式", "前四-前四-单式", "前五-前五-单式", "前六-前六-单式", "连赢-连赢-单式", "三连环-三连环-单式", "四连环-四连环-单式", "五连环-五连环-单式", "六连环-六连环-单式", "前五-前五-复式"],
		regex: '(0[1-9]\\s|10\\s){$}(0[1-9]|10){1}',
		filter: function(codes) {
      return _.chain(codes)
        .split(/(,|;|，|；|\n)/)
        .without('', ',', ';', '，', '；', '\n')
        .map(item => _.trim(item))
        .value();
    },
		join: ',',
		sortSplit: ' ',
		hasZero:true,
		desc: '每注号码之间请使用逗号[,]、分号[;] 或回车隔开。注意：号码之间要用空格隔开，不足2位要在前面加0。'
	},
	// 11选5单式玩法
	choose5:{
    matcherNames: ["三码-三码-前三直选单式", "三码-三码-前三组选单式", "二码-二码-前二直选单式", "二码-二码-前二组选单式", "任选单式-任选单式-一中一", "任选单式-任选单式-二中二", "任选单式-任选单式-三中三", "任选单式-任选单式-四中四", "任选单式-任选单式-五中五", "任选单式-任选单式-六中五", "任选单式-任选单式-七中五", "任选单式-任选单式-八中五"],
		regex: '(0[1-9]\\s|10\\s|11\\s){$}(0[1-9]|10|11){1}',
		filter: function(codes) {
      return _.chain(codes)
        .split(/(,|;|，|；|\n)/)
        .without('', ',', ';', '，', '；', '\n')
        .map(item => _.trim(item))
        .value();
    },
		join: ',',
		sortSplit: ' ',
		hasZero:true,
		desc: '每注号码之间请使用逗号[,]、分号[;] 或回车隔开。注意：号码之间要用空格隔开，不足2位要在前面加0。'
	},
	//江苏快三 三不同号手动输入
	k3:{
		matcherNames: ["三不同号-三不同号-手动输入"],
		regex: '(?!\\d*?(\\d)\\d*?\\1)[1-6\\s]{$}',
		filter: function(codes) {
      return _.chain(codes)
        .split(/(,| |;|	|，|　|；|\n)/)
        .without('', ',', ' ', ';', '	', '，', '；', '　', '\n')
        .map(item => _.trim(item))
        .map(item => _.without(_.sortBy(_.split(item, '')), ',').join(''))
        .filter(item => _.uniq(item.split('')).length == 3)
        .value();
    },
		desc: '每注号码之间请用一个 空格[ ]、逗号[,] 或者 分号[;] 隔开'
	},
	//江苏快三 二不同号手动输入
	dif2:{
		matcherNames: ["二不同号-二不同号-手动输入"],
		regex: '(?!\\d*?(\\d)\\d*?\\1)[1-6\\s]{$}', 
		filter: function(codes) {
      return _.chain(codes)
        .split(/(,| |;|	|，|　|；|\n)/)
        .without('', ',', ' ', ';', '	', '，', '；', '　', '\n')
        .map(item => _.trim(item))
        .map(item => _.without(_.sortBy(_.split(item, '')), ',').join(''))
        .filter(item => _.uniq(item.split('')).length == 2)
        .value();
    },
		desc: '每注号码之间请用一个 空格[ ]、逗号[,] 或者 分号[;] 隔开'
	},
	//江苏快三 二同号手动输入
	sk2:{
		matcherNames: ["二同号单选-二同号单选-手动输入"],
		regex:'[1-6\\s]{$}',
		filter: function(codes) {
      return _.chain(codes)
        .split(/(,| |;|	|，|　|；|\n)/)
        .without('', ',', ' ', ';', '	', '，', '；', '　', '\n')
        .map(item => _.trim(item))
        .map(item => _.without(_.sortBy(_.split(item, '')), ',').join(''))
        .filter(item => _.uniq(item.split('')).length == 2)
        .value();
    },
		desc: '每注号码之间请用一个 空格[ ]、逗号[,] 或者 分号[;] 隔开'
	},
	// 默认
	default:{
		regex: '[0-9\\s]{$}',
		filter: function(codes) {
      return _.chain(codes)
        .split(/(,| |;|	|，|　|；|\n)/)
        .without('', ',', ' ', ';', '	', '，', '；', '　', '\n')
        .map(item => _.trim(item))
        .value();
    },
		join: ' ',
		desc: '每注号码之间请用一个 空格[ ]、逗号[,] 或者 分号[;] 隔开'
	}
}

export function getSingleMethod() {
  return SPECIAL_SINGLE;
}